import { render, staticRenderFns } from "./PrivacyPolicyUs.vue?vue&type=template&id=271a56d9&scoped=true"
import script from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyUs.vue?vue&type=style&index=0&id=271a56d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a56d9",
  null
  
)

export default component.exports